import { render } from "./link.vue?vue&type=template&id=c0d49512"
import script from "./link.vue?vue&type=script&lang=js"
export * from "./link.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/partials/link.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0d49512"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0d49512', __exports__)) {
    api.reload('c0d49512', __exports__)
  }
  
  module.hot.accept("./link.vue?vue&type=template&id=c0d49512", () => {
    api.rerender('c0d49512', render)
  })

}


export default __exports__